
import Api from "./Api";

class dashboardService {
    getAll = (params = {}) => Api.get(`/api/dashboard/key-figures`, params);
}
export default new dashboardService();